import React from 'react'
import Header from '../../../Components/Header'

function Role() {
    return (
        <div>
            <Header text={"Battlefield Role"} link={'/datasheet/role'} />
            <div>
                Data
            </div> <br />
        </div>
    )
}

export default Role